import React from 'react';
import { Target, Award, Users, Heart, Zap, Shield, Truck, HeadphonesIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import BusinessLegalSummary from '../components/layout/BusinessLegalSummary';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Hakkımızda
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            LeaserTech olarak, teknoloji dünyasında kaliteli ve yenilikçi ürünler sunmak için yola çıktık.
          </p>
        </div>

        {/* Misyon ve Vizyon */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="bg-white rounded-lg shadow-md p-8">
            <div className="flex items-center mb-4">
              <Target className="h-8 w-8 text-orange-600 mr-3" />
              <h2 className="text-2xl font-bold text-gray-900">Misyonumuz</h2>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Türkiye'nin her yerindeki müşterilerimize en kaliteli elektronik aksesuarları 
              en uygun fiyatlarla sunmak ve teknolojiyi herkesin erişebileceği hale getirmek. 
              Müşteri memnuniyetini ön planda tutarak, güvenilir ve hızlı bir alışveriş deneyimi sunmak.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-8">
            <div className="flex items-center mb-4">
              <Award className="h-8 w-8 text-orange-600 mr-3" />
              <h2 className="text-2xl font-bold text-gray-900">Vizyonumuz</h2>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Türkiye'nin önde gelen e-ticaret platformlarından biri olmak ve elektronik aksesuar 
              sektöründe müşterilerimizin ilk tercihi haline gelmek. Sürekli gelişen teknolojiye 
              ayak uydurarak, yenilikçi ürünler ve hizmetler sunmak.
            </p>
          </div>
        </div>

        {/* Değerlerimiz */}
        <div className="bg-white rounded-lg shadow-md p-8 mb-16">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">Değerlerimiz</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="h-8 w-8 text-orange-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Müşteri Odaklılık</h3>
              <p className="text-gray-600 text-sm">
                Müşterilerimizin ihtiyaçlarını anlamak ve onlara en iyi hizmeti sunmak birinci önceliğimizdir.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="h-8 w-8 text-orange-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Güvenilirlik</h3>
              <p className="text-gray-600 text-sm">
                Tüm işlemlerimizde şeffaflık ve güvenilirlik ilkesiyle hareket eder, sözümüzü tutarız.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Zap className="h-8 w-8 text-orange-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Yenilikçilik</h3>
              <p className="text-gray-600 text-sm">
                Teknolojideki gelişmeleri yakından takip eder, müşterilerimize en güncel ürünleri sunarız.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Truck className="h-8 w-8 text-orange-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Hızlı Teslimat</h3>
              <p className="text-gray-600 text-sm">
                Siparişlerinizi en kısa sürede, güvenli bir şekilde adresinize ulaştırmak için çalışırız.
              </p>
            </div>
          </div>
        </div>

        {/* Hikayemiz */}
        <div className="bg-gradient-to-r from-orange-50 to-orange-100 rounded-lg shadow-md p-8 mb-16">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-6">Hikayemiz</h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-gray-800 text-lg leading-relaxed mb-4">
              LeaserTech, teknoloji tutkunu bir ekip tarafından kuruldu. Amacımız, 
              kaliteli elektronik aksesuarları herkesin erişebileceği fiyatlarla sunmak 
              ve müşterilerimize en iyi alışveriş deneyimini yaşatmaktı.
            </p>
            <p className="text-gray-800 text-lg leading-relaxed mb-4">
              Başlangıçta küçük bir ekiple yola çıktık, ancak müşteri memnuniyetine 
              verdiğimiz önem sayesinde kısa sürede büyüdük. Bugün, binlerce memnun 
              müşterimize hizmet veriyor ve Türkiye genelinde hızlı teslimat ağımızla 
              ürünlerimizi ulaştırıyoruz.
            </p>
            <p className="text-gray-800 text-lg leading-relaxed">
              Gelecekte de aynı kalite ve hizmet anlayışıyla, müşterilerimizin 
              yanında olmaya devam edeceğiz.
            </p>
          </div>
        </div>

        {/* Özellikler */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          <div className="bg-white rounded-lg shadow-md p-6 text-center">
            <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Binlerce Mutlu Müşteri</h3>
            <p className="text-gray-600">
              Türkiye'nin dört bir yanından güvenini kazanan binlerce müşterimiz var.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-6 text-center">
            <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <Award className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Kaliteli Ürünler</h3>
            <p className="text-gray-600">
              Sadece kaliteli ve güvenilir markalarla çalışıyor, ürünlerimizi özenle seçiyoruz.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-6 text-center">
            <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <HeadphonesIcon className="h-6 w-6 text-white" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">7/24 Destek</h3>
            <p className="text-gray-600">
              Müşteri hizmetlerimiz her zaman yanınızda, sorularınızı hızlıca yanıtlıyoruz.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md p-8 mb-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">İşletme bilgileri</h2>
          <p className="text-gray-600 mb-6">
            LeaserTech yalnızca online mağaza olarak faaliyet gösterir. Resmi satıcı ve vergi bilgilerimiz aşağıdadır.
          </p>
          <BusinessLegalSummary className="text-gray-700" />
        </div>

        {/* CTA */}
        <div className="bg-white rounded-lg shadow-md p-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Bize Katılın ve Kaliteli Ürünlerle Tanışın
          </h2>
          <p className="text-gray-600 mb-6">
            Geniş ürün yelpazemizden faydalanın ve özel kampanyalarımızdan haberdar olun.
          </p>
          <div className="flex justify-center space-x-4">
            <Link
              to="/products"
              className="bg-orange-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-600 transition-colors"
            >
              Ürünlerimizi İnceleyin
            </Link>
            <Link
              to="/contact"
              className="bg-gray-200 text-gray-800 px-6 py-3 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
            >
              İletişime Geçin
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;








